module.exports = __webpack_public_path__ + "img/Walls_text05_pressAZ.6c245141.png";